/**
 * Thin chrome wrapper — keeps SVG spider, forces sharp TensorLake card + amber series.
 */
import { lazy, Suspense } from "react";
import type { Model } from "@/types";
import type { SpiderPanel } from "@/components/compare/SpiderRadarCard";
import { StatusDot } from "./StatusDot";

const SpiderRadarCard = lazy(() =>
  import("@/components/compare/SpiderRadarCard").then((m) => ({
    default: m.SpiderRadarCard,
  })),
);

export function CompareSpider({
  models,
  compact = false,
  panel = "all",
}: {
  models: Model[];
  compact?: boolean;
  panel?: SpiderPanel;
}) {
  return (
    <section
      className={
        compact
          ? "compare-spider-compact flex min-h-0 flex-1 flex-col"
          : "mb-5"
      }
    >
      {!compact ? (
        <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
          <p className="eyebrow" style={{ marginBottom: 0 }}>
            03 / BENCHMARK
          </p>
          <StatusDot kind="live" label="CAPABILITY SPIDER" />
        </div>
      ) : null}
      <Suspense
        fallback={
          <div className="panel panel-pad">
            <p className="muted" style={{ margin: 0 }}>
              Loading capability spider…
            </p>
          </div>
        }
      >
        <SpiderRadarCard models={models} compact={compact} panel={panel} />
      </Suspense>
    </section>
  );
}
